import { call, put, takeLatest } from 'redux-saga/effects';

import * as url from '../../helpers/url_helper';

// Crypto Redux States
import { EntitiesTypes } from './actionTypes';
import {
  getEntitiesByTypeSuccess,
  getEntitiesByTypeFail,
  getEntitiesListSuccess,
  getEntitiesListFail,
  getEntitySuccess,
  getEntityFail,
} from './actions';

export const fetchEntities = async (data: any) => {
  let user;

  const getAuthUser = localStorage.getItem('authUser');

  if (getAuthUser) user = JSON.parse(getAuthUser);

  const path = url.API_URL;
  const query = `
    query {
        GetEntitiesByType( Entities:{ userId:${user.id} } ){
          id
          clientId
          entityType
          name
          createdOn
          address_Street
          address_City
          address_State
          address_ZipCode
          address_Country
          address_Description
          address_ContactName
          address_ContactPhone
          address_ContactFax
          address_ContactEmail
          address_PortCode
          billingAddress_Street
          billingAddress_City
          billingAddress_State
          billingAddress_ZipCode
          billingAddress_Country
          billingAddress_Description
          billingAddress_ContactName
          billingAddress_ContactPhone
          billingAddress_ContactFax
          billingAddress_ContactEmail
          billingAddress_PortCode
          accountNumber
          contactFirstName
          contactLastName
          exporterID
          exporterIDType
          transactionDueDays
          bondReferenceNumber
          creditLimit
          dateOfBirth
          dbClassType
          entityID
          flags
          isBillingClient
          isInactive
          isKnownShipper
          isRemoteUser
          knownShipperExpirationDate
          notes
          phoneExtension
          status
          suretyCode
          usesCollect
          website
          GUID
        }
      }    
    `;
  const response = await fetch(path, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query,
    }),
  }).then((res) => res.json());
  return response?.data;
};

function* fetchEntitiesSaga(data: any) {
  try {
    const response: Promise<any> = yield call(fetchEntities, data.payload);
    yield put(getEntitiesByTypeSuccess(response));
  } catch (error) {
    yield put(getEntitiesByTypeFail(error));
  }
}

//----------------------------------------------------------------------------

const getEntitiesListQuery = async ({
  pagination: { sizePerPage, page },
  form = { dynamicFilter: '' },
  clientId = undefined,
}: any) => {
  let user;
  const getAuthUser = localStorage.getItem('authUser');

  const dynamicFilter = form.dynamicFilter;

  if (getAuthUser) user = JSON.parse(getAuthUser);

  const query = `query {
		GetEntitiesList(
		  Entities:{
			${clientId ? ', clientId: "' + clientId + '"' : `userId:${user.id}`}
      order : "${form.order}",
		  	${dynamicFilter}
		
		}, 
		  Pagination:{ sizePage:${sizePerPage}, actualPage:${page} }
			)
		{
		  milestoneConfig {
			OperationType
			OperationName
			userId
			text
			dataField
			visibleInTable
			visibleInModalHeader
			visibleInMiddle
			visibleInModalFooter
			isMilestone
			hidden
			visibleInModalBody
			visibleInModalTotal
			isCustomField
			showInFilters
			order
			data{
			  id
			  name
			  }
			},
		  entitiesData{
        id
        clientId
        entityType
        name
        createdOn
        address_Street
        address_City
        address_State
        address_ZipCode
        address_Country
        address_Description
        address_ContactName
        address_ContactPhone
        address_ContactFax
        address_ContactEmail
        address_PortCode
        billingAddress_Street
        billingAddress_City
        billingAddress_State
        billingAddress_ZipCode
        billingAddress_Country
        billingAddress_Description
        billingAddress_ContactName
        billingAddress_ContactPhone
        billingAddress_ContactFax
        billingAddress_ContactEmail
        billingAddress_PortCode
        accountNumber
        contactFirstName
        contactLastName
        exporterID
        exporterIDType
        transactionDueDays
        bondReferenceNumber
        creditLimit
        dateOfBirth
        dbClassType
        entityID
        flags
        isBillingClient
        isInactive
        isKnownShipper
        isRemoteUser
        knownShipperExpirationDate
        notes
        phoneExtension
        status
        suretyCode
        usesCollect
        website
        GUID
		  },
		  CountItems
		}
	  }`;

  const response = await fetch(url.API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ query }),
  }).then((resp) => {
    return resp.json();
  });

  return response.data.GetEntitiesList;
};

function* getEntitiesListSaga({ payload }: any) {
  try {
    const response: Promise<any> = yield call(getEntitiesListQuery, payload);
    yield put(getEntitiesListSuccess(response));
  } catch (error) {
    yield put(getEntitiesListFail(error));
  }
}
//----------------------------------------------------------------------------
const getEntityQuery = async ({ entityId }: any) => {
  const query = `query{
		GetEntity(Entity:{id:${entityId}}){
		  entity{
        id
        clientId
        entityType
        name
        createdOn
        address_Street
        address_City
        address_State
        address_ZipCode
        address_Country
        address_Description
        address_ContactName
        address_ContactPhone
        address_ContactFax
        address_ContactEmail
        address_PortCode
        billingAddress_Street
        billingAddress_City
        billingAddress_State
        billingAddress_ZipCode
        billingAddress_Country
        billingAddress_Description
        billingAddress_ContactName
        billingAddress_ContactPhone
        billingAddress_ContactFax
        billingAddress_ContactEmail
        billingAddress_PortCode
        accountNumber
        contactFirstName
        contactLastName
        exporterID
        exporterIDType
        transactionDueDays
        bondReferenceNumber
        creditLimit
        dateOfBirth
        dbClassType
        entityID
        flags
        isBillingClient
        isInactive
        isKnownShipper
        isRemoteUser
        knownShipperExpirationDate
        notes
        phoneExtension
        status
        suretyCode
        usesCollect
        website
        GUID
		  }
		}
	  }`;

  const response = await fetch(url.API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ query }),
  }).then((resp) => {
    return resp.json();
  });

  return response.data.GetEntity;
};

function* getEntitySaga({ payload }: any) {
  try {
    const response: Promise<any> = yield call(getEntityQuery, payload);
    yield put(getEntitySuccess(response));
  } catch (error) {
    yield put(getEntityFail(error));
  }
}

function* EntitiesSaga() {
  yield takeLatest(EntitiesTypes.GET_ENTITIES_BY_TYPE, fetchEntitiesSaga);
  yield takeLatest(EntitiesTypes.GET_ENTITIES_LIST, getEntitiesListSaga);
  yield takeLatest(EntitiesTypes.GET_ENTITY, getEntitySaga);
}

export default EntitiesSaga;
